import React, { SetStateAction, useEffect, useState } from 'react'
import { Box, Button, Card, CardContent, Checkbox, Chip, Container, dialogActionsClasses, FormControl, FormControlLabel, MenuItem, Paper, Select, SelectChangeEvent, Slider, Stack, TextField, Typography } from '@mui/material'
import variables from "../../../assets/styles/variables.module.scss";
import OldAgent from '../../../Shared-ui/Types/OldAgent';
import { StartLoading, StopLoading } from '../../../Shared-ui/Store/LoadingReducer/LoaderActions';
import { ShowError, ShowSuccess } from '../../../Shared-ui/Store/MessageReducer/MsgActions';
import MetaInstance from '../../../Services/AxiosInstance/MetaInstance';
import { useDispatch } from 'react-redux';
import { Model, Prompt } from '../../../Shared-ui/Types/common';
import { CREATE_MODELS, GET_MODELS, GET_PROMPTS, GET_TEMPLATES } from '../../../Services/Endpoint';
import { NotSelected } from '../../../Constant/Setting';
import Template from '../../../Shared-ui/Types/Template';
import { formatDate } from '../../../Shared-ui/utils/Common/Common';

const MAX = 1;
const MIN = 0;
const STEP = 0.1;
const marks = [
    {
        value: MIN,
        label: "",
    },
    {
        value: MAX,
        label: "",
    },
];

interface MyComponentProps {
    knowledgeBase: OldAgent | any
    setknowledgeBase: React.Dispatch<SetStateAction<OldAgent | any>>
    getknowledgeBase: any
    updateknowledgeBase: any
}


const FormOne: React.FC<MyComponentProps> = (props) => {
    const modelInitial: Model = {
        apiKey: "",
        description: "",
        endpoint: "",
        name: "",
        provider: "",
        modelName: "",
        deploymentName: "",
        apiVersion: ""
    }

    const maxLength = 100;
    const [temperature, setTemperature] = React.useState<number>(MIN);
    const [prompts, setPrompts] = useState<Prompt[]>([])
    const [templates, setTemplates] = useState<Template[]>([])
    const [model, setModel] = useState<Model>(modelInitial)
    const [models, setModels] = useState<Model[]>([])
    const [modelList, setModelList] = useState<Model[]>([])
    const [providerList, setProviderList] = useState<any>([]);
    const [updateClicked, setUpdateClicked] = useState<any>(false)
    const [selectedProvider, setselectedProvider] = useState<string>("")
    const [disableTemplate, setDisableTemplate] = useState<boolean>(false)
    const [selectedTemplate, setSelectedTemplate] = useState<Template>()
    // Define color variables for background and text
    const selectedBackgroundColor = "primary"; // Background color when selected
    const unselectedBackgroundColor = "default"; // Background color when unselected
    const [chatOptionList, setChatOptionsList] = useState<any>(["Document", "SQL", "Images", "Chat", "Excel"])

    const dispatch = useDispatch()
    const pathname = window.location.pathname;
    const basePath = pathname.split('/').slice(0, -1).join('/');

    useEffect(() => {
        getModels()
        getPrompts()
        getTemplates()
    }, [])

    useEffect(() => {
        if(selectedTemplate === undefined){
            disableTemplateOption()
        }
    }, [props.knowledgeBase])

    const saveData = async () => {
        //if (!selectedProvider || selectedProvider === NotSelected) {
        //    dispatch(ShowError("Please select a Provider"))
        //    return;
        //}
        if (!props.knowledgeBase?.gptModel || props.knowledgeBase?.gptModel === NotSelected) {
            dispatch(ShowError("Please select a Model"))
            return;
        } else {
            setDisableTemplate(true)
        }

        await props.updateknowledgeBase()
        setUpdateClicked(false)
    }


    const getPrompts = async () => {
        try {
            dispatch(StartLoading())
            const data = await MetaInstance.get(`${GET_PROMPTS}?page=${1}&limit=${1000}`).then(res => res?.data?.detail)
            setPrompts(data.response)
        } catch (err: any) {
            dispatch(ShowError(err?.response?.data?.detail?.response))
        } finally {
            dispatch(StopLoading())

        }
    }

    const getTemplates = async () => {
        try {
            dispatch(StartLoading())
            const data = await MetaInstance.get(`${GET_TEMPLATES}?group=""&page=${1}&limit=${1000}&search=""`).then(res => res?.data?.detail)
            setTemplates(data.response)
        } catch (err: any) {
            dispatch(ShowError(err?.response?.data?.detail?.response))
        } finally {
            dispatch(StopLoading())

        }
    }

    const getModels = async () => {
        try {
            dispatch(StartLoading())
            const data = await MetaInstance.get(`${GET_MODELS}`).then(res => res?.data?.detail)
            setModels(data.response)
            const newList = new Set()
            data.response.map((model: Model) => { newList.add(model.provider) })
            newList.add("Azure")
            setProviderList(Array.from(newList))
        } catch (err: any) {
            dispatch(ShowError(err?.response?.data?.detail?.response))
        } finally {
            dispatch(StopLoading())

        }
    }
    const handleModelChange = (event: SelectChangeEvent) => {
        const { name, value } = event.target
        props.setknowledgeBase((preVal: OldAgent) => ({ ...preVal, gptModel: value }))
        setUpdateClicked(true)
    };

    const handleChangeintruction = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target
        props.setknowledgeBase((preVal: OldAgent) => ({ ...preVal, instruction: value }))
    };


    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement> | SelectChangeEvent) => {
        const { name, value } = event.target
        setModel((preVal) => ({ ...preVal, [name]: value }))
    };

    const handleChangeProvider = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement> | SelectChangeEvent) => {
        setModelList([])
        const { name, value } = event.target
        const newModelList = models?.filter((model: Model) => model.provider === value) || []
        props.setknowledgeBase((preVal: OldAgent) => ({ ...preVal, provider: value }))
        setselectedProvider(value)
        setModelList(newModelList);
        setUpdateClicked(true)
    };

    const handleTemperatureChange = (_: Event, newValue: number | number[]) => {
        props.setknowledgeBase((preVal: OldAgent | Template) => ({ ...preVal, temperature: newValue }))
        setTemperature(newValue as number);
    };
    const handleChipClick = (prompt: Prompt) => {
        props.setknowledgeBase((preVal: OldAgent) => {
            let updatedPrompts = []
            const prompts = preVal.prompts || []
            const Isadded = prompts.some((item: Prompt) => item.name == prompt.name)
            if (Isadded) {
                updatedPrompts = prompts.filter((item: Prompt) => item.name !== prompt.name)
                return { ...preVal, prompts: updatedPrompts }
            } else {
                updatedPrompts = [...prompts, prompt]
                return { ...preVal, prompts: updatedPrompts };
            }
        })
    };

    const handleTemplateChange = (event: SelectChangeEvent) => {
       

    }
    const handleChatChange = (event: SelectChangeEvent) => {
        const { name, value } = event.target
        if (value === NotSelected) return
        props.setknowledgeBase((preVal: OldAgent) => {
            return {
                ...preVal, chatOption: {
                    option: value,
                    RagType: value === "Document" ? "Basics" : ''

                }
            }
        })

    }

    const disableTemplateOption = () => {
        if (props.knowledgeBase && props.knowledgeBase?.gptModel) {
            setDisableTemplate(true)
        } else {
            setDisableTemplate(false)
        }
    }

    return (
        <Container maxWidth="md">
            <Paper
                elevation={0}
                sx={{
                    padding: "24px 48px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    mb: 4,
                }}
            >
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: { md: "1fr 1fr" },
                        gap: 4,
                        gridAutoRows: "1fr",
                        mb: 2,
                    }}
                >
                    <Box>
                        <FormControl fullWidth required>
                            <Typography
                                variant="subtitle1"
                                sx={{ fontWeight: "500", color: variables.textColor2 }}
                            >
                                Provider
                            </Typography>
                            <Select
                                size="small"
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="provider"
                                value={props.knowledgeBase?.provider || NotSelected}
                                onChange={handleChangeProvider}
                                disabled={props.knowledgeBase?.gptModel && !updateClicked}
                                required
                            >
                                <MenuItem value={NotSelected}>Select Provider</MenuItem>
                                {providerList?.map((provider: string, index: number) => (
                                    <MenuItem value={provider} key={index}>{provider}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                    <Box>
                        {/* if agent  is new model not assigned */}
                        {!props.knowledgeBase?.gptModel || updateClicked ? (
                            <FormControl fullWidth required>
                                <Typography
                                    variant="subtitle1"
                                    sx={{ fontWeight: "500", color: variables.textColor2 }}
                                >
                                    Model
                                </Typography>
                                <Select
                                    size="small"
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={props.knowledgeBase?.gptModel || NotSelected}
                                    onChange={handleModelChange}
                                    required
                                >
                                    <MenuItem value={NotSelected}>Select Model</MenuItem>
                                    {modelList?.map((model, index) => (
                                        <MenuItem value={model.name} key={index}>{model.name}</MenuItem>
                                    ))}

                                </Select>
                            </FormControl>
                        ) : (
                            <>
                                {/* if agent model name already  assigned */}

                                <FormControl fullWidth required>
                                    <Typography
                                        variant="subtitle1"
                                        sx={{ fontWeight: "500", color: variables.textColor2 }}
                                    >
                                        Model
                                    </Typography>
                                    <TextField
                                        size="small"
                                        name="name"
                                        fullWidth
                                        id="outlined-basic"
                                        variant="outlined"
                                        // onChange={}
                                        disabled={true}
                                        value={props?.knowledgeBase?.gptModel}
                                        sx={{ fontSize: "14px" }}
                                        required
                                    />

                                </FormControl>
                            </>

                        )}
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: { md: "1fr" },
                        gap: 4,
                        gridAutoRows: "1fr",
                        mb: 2,
                    }}
                >
                    <Box>
                        <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: "500", color: variables.textColor2 }}
                        >
                            API Key
                        </Typography>
                        <TextField
                            size="small"
                            fullWidth
                            value={model.apiKey}
                            onChange={handleChange}
                            name="apiKey"
                            id="outlined-basic"
                            variant="outlined"
                        />
                    </Box>
                </Box>
                {selectedProvider === "Azure" && (<>
                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: { md: "1fr 1fr" },
                            gap: 4,
                            gridAutoRows: "1fr",
                            mb: 2,
                        }}
                    >
                        <Box>
                            <Typography
                                variant="subtitle1"
                                sx={{ fontWeight: "500", color: variables.textColor2 }}
                            >
                                API Base
                            </Typography>
                            <TextField
                                size="small"
                                fullWidth
                                id="outlined-basic"
                                name="endpoint"
                                value={model.endpoint}
                                onChange={handleChange}
                                variant="outlined"
                                sx={{ fontSize: "14px" }}
                            />
                        </Box>
                        <Box>
                            <Typography
                                variant="subtitle1"
                                sx={{ fontWeight: "500", color: variables.textColor2 }}
                            >
                                API Version
                            </Typography>
                            <TextField
                                size="small"
                                defaultValue="694e2786133d62292c1cdfrtyun23xa"
                                fullWidth
                                id="outlined-basic"
                                variant="outlined"
                                sx={{ fontSize: "14px" }}
                            />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: { md: "1fr" },
                            gap: 4,
                            gridAutoRows: "1fr",
                            mb: 2,
                        }}
                    >
                        <Box>
                            <Typography
                                variant="subtitle1"
                                sx={{ fontWeight: "500", color: variables.textColor2 }}
                            >
                                ChatGPT Deployment Name
                            </Typography>
                            <TextField
                                size="small"
                                defaultValue="gpt-4-tests"
                                fullWidth
                                id="outlined-basic"
                                variant="outlined"
                                sx={{ fontSize: "14px" }}
                            />
                        </Box>
                    </Box>

                </>)}

                {/* <Box>
                        <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: "500", color: variables.textColor2 }}
                        >
                            Embedding Deployment Name
                        </Typography>
                        <TextField
                            size="small"
                            defaultValue="text-embedding-ada-002-tests"
                            fullWidth
                            id="outlined-basic"
                            variant="outlined"
                            sx={{ fontSize: "14px" }}
                        />
                    </Box> */}
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: { md: "1fr 1fr" },
                        gap: 4,
                        gridAutoRows: "1fr",
                        mb: 2,
                    }}
                >
                    {/* chatoption selection not required in template ai settings */}
                    {basePath !== "/template" &&
                        <Box>
                            <FormControl fullWidth>
                                <Typography
                                    variant="subtitle1"
                                    sx={{ fontWeight: "500", color: variables.textColor2 }}
                                >
                                    Chat Option
                                </Typography>
                                <Select
                                    size="small"
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={props.knowledgeBase?.chatOption?.option || NotSelected}
                                    onChange={handleChatChange}
                                >
                                    <MenuItem value={NotSelected}>Select chat option</MenuItem>
                                    {chatOptionList?.map((option: string, index: number) => (
                                        <MenuItem value={option} key={index}>{option}</MenuItem>
                                    ))}

                                </Select>
                            </FormControl>
                        </Box>
                    }
                    <Box>
                        <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: "500", color: variables.textColor2 }}
                        >
                            Embedding Deployment Name
                        </Typography>
                        <TextField
                            size="small"
                            defaultValue="text-embedding-ada-002-tests"
                            fullWidth
                            id="outlined-basic"
                            variant="outlined"
                            sx={{ fontSize: "14px" }}
                        />
                    </Box>
                </Box>


                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: { md: "1fr" },
                        gap: 4,
                        gridAutoRows: "1fr",
                        mb: 2,
                    }}
                >
                    <Box>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mb: 1,
                            }}

                        >
                            <Typography
                                variant="subtitle1"
                                sx={{ fontWeight: "500", color: variables.textColor2 }}
                            >
                                System Instructions
                            </Typography>
                            <Box sx={{ minWidth: 120 }}>
                                <FormControl
                                    fullWidth
                                    size="small"
                                    sx={{
                                        minWidth: 200, // Set the minimum width to 200px
                                    }}
                                >
                                    {/* template selection not required in template ai settings */}
                                    {basePath !== "/template" && <Select
                                        size="small"
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={props.knowledgeBase?.templateId || NotSelected}
                                        onChange={handleTemplateChange}
                                        sx={{ fontSize: "14px" }}
                                        disabled={disableTemplate}
                                    >
                                        <MenuItem value={NotSelected} key={NotSelected}>Select template</MenuItem>

                                        {templates.map((template: Template, index: number) => (
                                            <MenuItem value={template.id} key={index}>{template.name}</MenuItem>

                                        ))}

                                    </Select>
                                    }
                                </FormControl>
                            </Box>
                        </Box>

                        <Box>
                            <TextField
                                value={props.knowledgeBase?.instruction || ""}
                                onChange={handleChangeintruction}
                                fullWidth
                                name="instruction"
                                id="multiline-with-counter"
                                variant="outlined"
                                multiline
                                rows={4}
                                placeholder="Type here..."
                                inputProps={{
                                    maxLength: maxLength, // Optional: Restricts max input length
                                }}
                                sx={{ fontSize: "14px" }}
                            />
                            <Typography
                                variant="body2"
                                align="left"
                                sx={{
                                    color:
                                        props.knowledgeBase?.instruction?.length === maxLength
                                            ? "error.main"
                                            : "text.secondary",
                                    mt: 1,
                                }}
                            >
                                {`${props.knowledgeBase?.instruction?.length}/${maxLength}`}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Box
                    sx={{
                        mb: 1,
                    }}
                >
                    <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: "500", color: variables.textColor2 }}
                    >
                        Prompts
                    </Typography>
                    <Card
                        key={0}
                        elevation={0}
                        variant="outlined"
                        sx={{
                            height: "155px",
                            overflow: "auto",
                        }}
                    >
                        <CardContent>
                            <Stack
                                direction="row"
                                sx={{
                                    display: "flex",
                                    gap: 1,
                                    flexWrap: "wrap",
                                }}
                            >
                                {prompts.map((prompt, index) => {
                                    const Isadded = props.knowledgeBase?.prompts?.map((item: any) => item.name).includes(prompt.name)
                                    return (
                                        Isadded ? (<>
                                            <Chip
                                                // key={`${prompt.createdAt}-${index}`}
                                                key={index}
                                                label={prompt.name}
                                                variant="filled"
                                                color={selectedBackgroundColor
                                                }
                                                onClick={() => handleChipClick(prompt)}
                                                sx={{
                                                    color: variables.whiteColor, // Set text color
                                                }}
                                            />

                                        </>) : (<>
                                            {/* {console.log(index)} */}
                                            <Chip
                                                key={prompt.createdAt}
                                                label={prompt.name}
                                                variant="outlined"
                                                color={unselectedBackgroundColor}
                                                onClick={() => handleChipClick(prompt)}
                                                sx={{
                                                    color: variables.textGray, // Set text color
                                                }}
                                            />
                                        </>)

                                    )
                                })}
                            </Stack>
                        </CardContent>
                    </Card>
                </Box>

                <Box>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Typography
                            variant="subtitle1"
                            gutterBottom
                            sx={{ fontWeight: "500", color: variables.textColor2 }}
                        >
                            Temperature
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            gutterBottom
                            sx={{ fontWeight: "500", color: variables.textColor2 }}
                        >
                            {props.knowledgeBase?.temperature || temperature}
                        </Typography>
                    </Box>
                    <Box>
                        <Slider
                            marks={marks}
                            step={STEP}
                            value={props.knowledgeBase?.temperature || temperature}
                            valueLabelDisplay="auto"
                            min={MIN}
                            max={MAX}
                            onChange={handleTemperatureChange}
                        />
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography
                                variant="body2"
                                onClick={() => setTemperature(MIN)}
                                sx={{ cursor: "pointer" }}
                            >
                                Reserved
                            </Typography>
                            <Typography
                                variant="body2"
                                onClick={() => setTemperature(MAX)}
                                sx={{ cursor: "pointer" }}
                            >
                                Creative
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        mt: 2,
                    }}
                >
                    <Button variant="contained" disableElevation onClick={() => saveData()}>
                        Save
                    </Button>
                </Box>
            </Paper>
            <Paper
                elevation={0}
                sx={{
                    padding: "24px 48px",
                    border: "1px solid #ccc", // Add an outline with a border
                    borderRadius: "8px", // Optional: Rounded corners
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                        sx={{ fontWeight: "500", color: variables.textColor2 }}
                    >
                        Training
                    </Typography>
                    <FormControlLabel
                        control={<Checkbox defaultChecked />}
                        label="Auto Train every 24 hrs"
                        sx={{
                            marginRight: 0,
                        }}
                    />
                </Box>
                <Box>
                    <Typography variant="subtitle2">Last trained at</Typography>
                    <Typography variant="body2" gutterBottom>
                        {props?.knowledgeBase?.lastTrained ? formatDate(props.knowledgeBase.lastTrained) : "--"}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                        }}
                    >
                        <Typography variant="subtitle2">Training Status</Typography>
                        <Box
                            sx={{
                                width: 12,
                                height: 12,
                                borderRadius: "50%",
                                backgroundColor: "green",
                            }}
                        />
                    </Box>
                    <Button variant="contained" disableElevation>
                        Save
                    </Button>
                </Box>
            </Paper>
        </Container>
    )
}

export default FormOne